module.exports = "<h5 class=\"mt-0\">\n\t\"{{displayTitle}}\"</h5>\n{{content}}";